"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var ref = _react.default.useRef();

  var _react$default$useSta = _react.default.useState(defaultValue),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      value = _react$default$useSta2[0],
      setValue = _react$default$useSta2[1];

  var onFocus = _react.default.useCallback(function () {
    if (!ref.current) return;
    ref.current.focus();
  }, []);

  var onClear = _react.default.useCallback(function () {
    setValue('');
    onFocus();
  }, []);

  var onChange = _react.default.useCallback(function (_ref) {
    var target = _ref.target;
    setValue(target.value);
  }, []);

  return {
    ref: ref,
    onChange: onChange,
    onFocus: onFocus,
    onClear: onClear,
    setValue: setValue,
    value: value
  };
};

exports.default = _default;